<template>
<div>
  <div>
    <h3> Co-Operators </h3>
    <v-layout row>
    <v-flex md12>
    <v-expansion-panel v-model="panel">
    <CoOperator v-for="cooperator in cooperators" 
    :cooperator="cooperator" 
    @delete="onDeleteItem($event)"
    :key="cooperator.id" />
    </v-expansion-panel>
    </v-flex>
    </v-layout>
  </div>
<span>
  <v-btn data-btn="add-operator"  @click="addTrustor()" flat icon color="green">
    <v-icon>person_add</v-icon>
  </v-btn>
  Add operator
</span>
<span>
  <v-btn data-btn="copy-operators-from-trustors"  @click="copyFromTrustors()" flat icon color="yellow">
    <v-icon>person_add</v-icon>
  </v-btn>
  Copy from Co-Trustors
</span>
</div>
</template>

<script>
import CoOperator from "./CoOperator.vue";

export default {
  data: () => ({
    panel: [true]
  }),
  components: {
    CoOperator
  },
  props: {
    cooperators: Array,
    cotrustors: Array,
  },
  computed: {},
  methods: {
    addTrustor() {
      console.log("Adding operator");
      this.cooperators.push({ id: this.cooperators.length + 1 });
    },
    onDeleteItem(cooperator) {
      this.$emit("deleteOperator", cooperator);
    },
    // Copy Trustors to Operators, they have their own fields so extra logic needed
    copyFromTrustors() {
      console.log("Copy Co-Trustors to Co-Operators");
      this.$emit("coTrustorsToOperators");
    }
  }
};
</script>

<style>
</style>
